import React from 'react';
import TheGlobe from './TheGlobe';

const Surroundings = () => {
  return (
    <section className="py-8 md:py-12">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold mb-4 md:mb-6">Your surroundings</h2>
      </div>
      <div className='overflow-hidden'>
        <TheGlobe />
      </div>

    </section>
  );
};

export default Surroundings;
